import { request } from '@/shared/api/request'

export const getWorkPlaceList = ({payload: {wpId}, params}) => {
	return request({
		url: `staff/wplace/${wpId}/list`,
		method: 'GET',
		params
	})
}
